




















































































import Vue from 'vue'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Modal from '@/components/Modal.vue'
import ScrollView from '@/components/ScrollView.vue'

@Component({
  components: {
    Modal,
    ErrorMessages,
    ScrollView
  }
})
export default class TermsPopup extends Vue {
}
